export default __webpack_public_path__ + "static/media/NB-IOT-TEMP.e88e2afc.png";